import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Clock } from 'lucide-react';
import { sopApi } from './api';
import SopCard from './components/SopCard';

const SopRecent = () => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    sopApi.recent()
      .then((r) => setDocs(r.data || []))
      .catch((err) => setError(err.message || 'Failed to load recent SOPs'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-slate-100">Recently Viewed</h2>
        <p className="text-sm text-slate-400 mt-1">The SOPs you&rsquo;ve opened most recently.</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-20 text-slate-400">
          <Loader2 className="w-6 h-6 animate-spin mr-2" /> Loading…
        </div>
      ) : error ? (
        <div className="p-4 bg-rose-500/10 border border-rose-500/30 rounded-lg text-rose-300 text-sm">{error}</div>
      ) : docs.length === 0 ? (
        <div className="text-center py-16 space-y-3">
          <Clock className="w-12 h-12 text-slate-600 mx-auto" />
          <p className="text-slate-300 font-medium">Nothing here yet.</p>
          <p className="text-sm text-slate-500">
            SOPs you open will show up here.{' '}
            <Link to="/tiles/ksp_sops/library" className="text-indigo-400 hover:text-indigo-300 underline">
              Browse the library
            </Link>
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {docs.map((doc) => <SopCard key={doc.id} doc={doc} view="list" />)}
        </div>
      )}
    </div>
  );
};

export default SopRecent;
